import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import { LoiSubmissionPackage } from '../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiSubmissionPackage';
import { TimelineActionType } from '../../../slices/marketplace/timeline/models/timeline-action-type.model';
import { LevelOfService } from '../../../slices/marketplace/timeline/models/enums/level-of-service.enum';

import './LoiFormReviewModal.scss';

const LOI_REVIEW_MODAL_WIDTH = 1200;

export interface LoiFormReviewModalProps {
    isVisible: boolean;
    onClose: () => void;
    engagementId: number;
    loiFormId: string;
    eventId: string;
    documentDetailsId: string | null;
    documentName: string | null;
    buyerName: string;
    onSubmitComplete: () => void;
    levelOfService?: number;
    isAdminEventActive: boolean;
}

export const LoiFormReviewModal = (props: LoiFormReviewModalProps) => {
    return (
        <div className="loi-form-review-modal">
            <Rodal
                visible={props.isVisible}
                onClose={props.onClose}
                className="checkout-modal loi-form-review-rodal"
                width={LOI_REVIEW_MODAL_WIDTH}
                customStyles={{ maxWidth: '90vw' }}
                animation="fade"
                showMask={true}
                centered>
                <ModalHeader>
                    <span>LOI Form — {props.buyerName}</span>
                </ModalHeader>
                <ModalBody>
                    <LoiSubmissionPackage
                        loiFormId={props.loiFormId}
                        engagementId={props.engagementId}
                        eventId={props.eventId}
                        isReadonly={false}
                        actionType={TimelineActionType.VetValueLoiFormCreation}
                        documentDetailsId={props.documentDetailsId ?? undefined}
                        uploadedDocumentName={props.documentName ?? undefined}
                        onDataChange={props.onSubmitComplete}
                        isFsb={props.levelOfService === LevelOfService.FullServiceBrokerage}
                        isAdmin={true}
                        canSubmit={props.isAdminEventActive}
                    />
                </ModalBody>
            </Rodal>
        </div>
    );
};
